Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styledSystem = void 0;

var default_config_1 = require("./config/default-config");

var default_theme_1 = require("./config/default-theme");

var parse_styles_1 = require("./parse-styles");

exports.styledSystem = function (config, theme, props) {
  if (!props || !('ncss' in props) || typeof props.ncss !== 'object') {
    return;
  }

  if (!config || Object.entries(config).length === 0) {
    console.log("Config not found, using default config");
    config = default_config_1.defaultConfig;
  }

  if (!theme || Object.entries(theme).length === 0) {
    console.log("Theme not found, using default theme");
    theme = default_theme_1.defaultTheme;
  }

  return parse_styles_1.parseStyles({
    config: config,
    theme: theme,
    props: props.ncss
  });
};